<div class="group-list-container">
  <div class="aw-list-title">Group List</div>

  <ul class="aw-list">
    <li class="aw-list-item"
      *ngFor="let group of groupList | objArraySort:'name'"
      (click)="clickGroup(group.id)"
      [style.background]="selectedId === group.id ? '#FFFFFF' : '#F8F9FA'">
      <object type="image/svg+xml" style="width: 14px; height: 20px; margin-right: 8px;"
          data="assets/images/group/ic_group_light.svg">Your browser does not support SVGs</object>
        {{group.name}}
      <div class="aw-list-item-badge">
        {{group.deviceList.length}}
      </div>
    </li>
    <li class="aw-list-item-light" style="color: #ACB4BB" (click)="clickGroup(unassigned.id)" [style.background]="(selectedId == null) ? '#FFFFFF' : '#F8F9FA'">
      <object type="image/svg+xml" style="width: 14px; height: 20px; margin-right: 8px;"
          data="assets/images/group/ic_group_light.svg">Your browser does not support SVGs</object>
        Unassigned
      <div class="aw-list-item-badge">
        {{unassigned.deviceList.length}}
      </div>
    </li>
  </ul>
</div>
